import "./Why.css"
export default function Why(){
    return(
        <div className="why" dir="rtl" id="why">
         
                   <div className="right" dir="rtl">
                   <p className="heads"
                   >لماذا دكتور مصطفي الخشت ؟
                   </p>
                   <div className="disc"> 
                      <p className="line">
انطلاقا من شفه لمساعدة الاخرين                       </p>
                      <p className="line">
                      وتحسين حياتهم للافضل اختار دكتور مصطفى الخشت دراسة
  
                      </p>
                      <p className="line">
الطب وبالاخص علاج تاخر الانجاب                      </p>
                   

                   </div>
                   </div>
                   <div className="left">
                    <div className="up" >
                    <img className="img"src="/assets/R-removebg-preview (13) 1.png"/>
                     <div className="flex">
                     <div className="two">
                       <div className="image" >  
                     <img src="\assets\Group.png"style={{width:"70px"}} />
                     <div className="num">+5,000</div>
                     <div className="discrip">  متابعة مريض سنويا    </div>

                      </div>
                       </div>

                    <div className="one">
                        <div className="image" >
                        <img  src="\assets\cup-1-svgrepo-com (1).svg"/>
                        <div className="num">+20</div>
                        <div className="discrip">    عام من الخبرة  </div>

                        </div>                       
                       </div>
                       <div className="two">
                       <div className="image" >  
                     <img style={{width:"35px"}} src="\assets\smile-beam-svgrepo-com (1).svg"/>
                     <div className="num">+5,000</div>
                     <div className="discrip">    عملية جراحية ناجحة    </div>

                      </div>
                       </div>
                     </div>
                  <div> 
                     </div>

                    </div>

                   </div>
        
       
    </div>
    )
}